import React from 'react';
import classNames from 'classnames';

import { CLASSES } from '@/constants/classes';

// Dashboard card.
export function DashboardCard({ children, page, className }: any) {
  return (
    <div
      className={classNames(
        CLASSES.DASHBOARD_CARD,
        {
          [CLASSES.DASHBOARD_CARD_PAGE]: page,
        },
        className,
      )}
    >
      {children}
    </div>
  );
}
